import React, { useState, useEffect } from "react";
import "./styles/LandingPage.css";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

const logo = `${process.env.PUBLIC_URL}/logonextremedy.png`;

function LandingPage() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="landing-page">
      {/* 🌟 Navigation Header */}
      <header className="header">
        <div className="header-content">
          <Link to="/" className="logo" aria-label="Next Remedy Home">
            <img 
              src={logo} 
              alt="Next Remedy Logo" 
              className="logo-img"
              width="150" 
              height="40"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="nav desktop-nav">
            <Link to="/pricing">Pricing</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/login" className="button button-secondary">Log in</Link>
            <Link to="/signup" className="button button-primary">Sign Up</Link>
          </nav>

          {/* ☰ Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle Menu"
          >
            {menuOpen ? "✕" : "☰"}
          </button>
        </div>

        {/* Mobile Nav Menu */}
        {menuOpen && (
          <nav className="mobile-nav">
            <Link to="/pricing" onClick={() => setMenuOpen(false)}>Pricing</Link>
            <Link to="/privacy-policy" onClick={() => setMenuOpen(false)}>Privacy Policy</Link>
            <Link to="/terms-of-service" onClick={() => setMenuOpen(false)}>Terms of Service</Link>
            <Link to="/login" onClick={() => setMenuOpen(false)}>Log in</Link>
            <Link to="/signup" onClick={() => setMenuOpen(false)}>Sign Up</Link>
          </nav>
        )}
      </header>

      {/* 🌟 Main Content */}
      <main className="main-content">
        <section className="hero-container">
          <br />
          <h1 className="hero-text">
            All-in-one tool for <span className="highlight">musicians</span> to reach<span className="highlight">real fans</span>
          </h1>
          <p className="sub-text">
            Instantly reach TikTok users who posted with your target hashtag. <br />
            Send your music via Gmail in just a few clicks — no tech skills needed.
          </p>
          <Link to="/signup" className="button button-primary">
            Get Started
          </Link>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default LandingPage;